exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ExpendMenuItem-module__grid___3z4Kt{display:grid;gap:1em}.ExpendMenuItem-module__wrapper___oAJTA{display:flex;justify-content:space-between;align-items:center;cursor:pointer}.ExpendMenuItem-module__wrapper___oAJTA h4{margin:0}.ExpendMenuItem-module__wrapper___oAJTA svg{color:#b4bac3;transition:all .3s ease-in-out}.ExpendMenuItem-module__wrapper___oAJTA svg.ExpendMenuItem-module__rotated___1Wyuj{transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"grid": "ExpendMenuItem-module__grid___3z4Kt",
	"wrapper": "ExpendMenuItem-module__wrapper___oAJTA",
	"rotated": "ExpendMenuItem-module__rotated___1Wyuj"
};